export default __webpack_public_path__ + "static/media/visit.a0ebff88.png";